import { useRef, useState } from 'react';
import { useI18n } from '@/i18n';

// Hosted Stripe Checkout cannot render inside an iframe. Reserve a top-level window
// synchronously in the user's click, BEFORE awaiting registration/session creation.
export function useHostedCheckout(consent) {
  const {tx}=useI18n();
  const agreement=useRef(null);
  agreement.current=consent.submission;
  const [link,setLink]=useState(null);
  const [error,setError]=useState('');
  const cancel=ticket=>{
    try { if(ticket?.window&&!ticket.window.closed&&ticket.window.location.href==='about:blank')ticket.window.close(); } catch {}
  };
  const prepare=()=>{
    if(!agreement.current)throw new Error('Photography and publicity consent is required before booking or payment.');
    setError('');setLink(null);
    const ticket={acceptanceId:agreement.current.acceptance_id,embedded:window.self!==window.top,window:null};
    if(ticket.embedded){
      ticket.window=window.open('about:blank',`allrounder-checkout-${crypto.randomUUID()}`);
      if(ticket.window){
        ticket.window.opener=null;
        ticket.window.document.title='Allrounder';
        ticket.window.document.body.textContent=tx('Opening secure payment…');
      }
    }
    return ticket;
  };
  const open=(url,ticket)=>{
    let parsed;
    try { parsed=new URL(url); } catch {}
    if(!parsed||parsed.protocol!=='https:'||parsed.hostname!=='checkout.stripe.com'||parsed.username||parsed.password||parsed.port){
      cancel(ticket);setError('The payment link is unavailable. Please try again.');
      throw new Error('The payment link is unavailable. Please try again.');
    }
    if(!agreement.current||agreement.current.acceptance_id!==ticket.acceptanceId){
      cancel(ticket);setError('Please review your consent before opening payment.');return;
    }
    setLink({url:parsed.href,acceptanceId:ticket.acceptanceId});
    if(!ticket.embedded){window.location.assign(parsed.href);return;}
    try { if(ticket.window&&!ticket.window.closed){ticket.window.location.replace(parsed.href);return;} } catch {}
    // Popup blocked/closed: retain an explicit user-gesture button, never navigate the iframe.
  };
  const reopen=()=>{
    if(link&&agreement.current?.acceptance_id===link.acceptanceId)window.open(link.url,'_blank','noopener,noreferrer');
  };
  return {prepare,open,cancel,reopen,error,link,canOpen:Boolean(link&&consent.submission?.acceptance_id===link.acceptanceId)};
}